import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { isInternalUserLoggedIn } from '../../../helpers/securityHelper';
import { LOCATION } from '../../../types';

export default function ProtectedRoute(props) {
    const { location } = props;
    const internalUserData = useSelector((state) => get(state, 'login.user', null));

    // All micro-services must dispatch the checkLoggedIn action to load
    // internalUserData. Failure to do this will result in stuck blank pages
    if (isInternalUserLoggedIn()) {
        if (!internalUserData) {
            return null;
        }
        return <Route {...props} />;
    }

    const { pathname } = location;
    let urlParam = '';

    if (pathname) {
        urlParam = `?redirect=${pathname}`;
    }

    // We can't use <Redirect> here because the micro-services
    // setup breaks React Router and would result in a bear page
    window.location.assign(`/internal/account/login${urlParam}`);

    return null;
}

ProtectedRoute.propTypes = {
    location: LOCATION,
    isInternal: PropTypes.bool
};

ProtectedRoute.defaultProps = {
    isInternal: false
};